export default "__VITE_ASSET__h38WjMt2__"